import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class BodyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/dev/github/ng4wedding/wedding/src/app/pages/body/body.component.ts